import { render, staticRenderFns } from "./ContactMenu.vue?vue&type=template&id=337238bd&"
import script from "./ContactMenu.vue?vue&type=script&lang=js&"
export * from "./ContactMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContactMenu.vue?vue&type=style&index=0&id=337238bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports